import { render, staticRenderFns } from "./product_card.vue?vue&type=template&id=e824b6b4&"
import script from "./product_card.vue?vue&type=script&lang=js&"
export * from "./product_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports